const isLocal = window.location.hostname === 'localhost';

export const API_URL = isLocal
  ? 'http://localhost:5257' // Local backend
  : 'https://turnieje.azurewebsites.net'; // Production backend
